<template lang="html">
  <!-- <div style="background-color:#f5f5f5;"> -->
    <div style="background-image: url('./static/image/coding3.jpg') !important;background-size: 100% 100% ; height: 100%; width: 100%; background-repeat: no-repeat;margin-top: 0vh; overflow-y: hidden;"
    >
    <!-- </div > -->
     <Navbar/>
    <!-- </div> -->
    <v-container style="height: calc(100vh - 64px); margin-top:7vh;"  >
      <v-layout row :style="layoutLogin" justify-center = true class="hidden-sm-and-down">
        <v-card class="setBolderRegister" style="background-color: #000000b8; width:33vw" >
          <v-card-text style="margin-top: 0; padding-left: 40px; padding-right: 40px; ">
            <h2 style="color:white;" class="centerDiv CSChatThai">ลงทะเบียนผู้ใช้งาน</h2>
              <v-layout>
                <v-flex xs12> <v-form v-model="valid" ref="form" class="CSChatThai labeltext">
                  <div style="margin-top: 30px;text-align: center;" v-if="type=='first'">
                    <v-text-field
                    dark
                      label="เบอร์โทรศัพท์"
                      v-model="phoneNumber"
                      mask="###-###-####"
                      :rules="phoneRules"
                      required
                      prepend-icon="phone"
                      single-line
                      style="width: 100% !important; color: #2562af !important;"
                    ></v-text-field>
                    <!-- <v-btn  @click="otp()" :disabled="phone === ''" :loading="loading" color="#2562af" style="margin-bottom: 30px;width: 40%; border-radius:50px; color:white;">ขอ OTP</v-btn> -->
                    <v-btn @click="getotp()" color="#2562af" :disabled="phoneNumber === ''" style="justify-self: center;margin-bottom: 30px;width: 20%; border-radius:50px; color:white;">ขอ OTP</v-btn>
                  </div>

                    <div style="margin-top: 30px;text-align: center; color:white;" v-else-if="type=='otp'">
                      <p >เบอร์โทร: {{phoneNumber}}</p>
                      <p  v-if="Refcode">Refcode: {{Refcode}}</p>
                      <div style="display: flex;">
                        <v-text-field
                          dark
                          label="OTP"
                          v-model="otpCode"
                          required
                          single-line
                          maxlength="6"
                          style="width: 100% !important; color: #2562af !important;"
                        ></v-text-field>

                        <v-btn depressed class="btnloginwebOneid_white" style="width: 20%; margin-top: 5px !important;" :disabled="counting" @click="getotp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                          <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
                        </countdown>
                        <span v-if="!counting">ส่ง OTP </span>
                      </v-btn>
                    </div>
                  <v-checkbox
                    v-model="checkbox"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    dark>
                    <div slot="label" style="color: #2562af !important;">
                      ยอมรับ
                      <a style="color: gray !important; text-decoration: underline;" @click.stop="conditions = true">เงื่อนไขการใช้งาน</a>
                    </div>
                  </v-checkbox>
                  <v-dialog v-model="conditions" width="70%">
                    <v-card>
                      <v-card-title class="title">เงื่อนไขการใช้งาน</v-card-title>
                      <v-card-text v-html="content">
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        flat
                        color="blue"
                        @click="conditions = false"
                        >ตกลง</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                <div style="justify-content: center; align-items: center; display: flex; margin-bottom: 5vh;">
                  <v-btn @click="backtoInputphone()" outline color="blue-grey" style="color: white !important;border-radius: 20px;">ย้อนกลับ</v-btn>
                  <v-btn
                    @click="loginWithotp()"
                    :disabled="!(valid && otpCode.length==6)"
                    color="success"
                    :loading="isLoading"
                    style="border-radius: 20px;"
                    >
                    สมัครสมาชิก
                  </v-btn>
              </div>
                      </div>
              <div  style="justify-content: center;display: flex;" >
                <span style="color: white; font-size: 12px;" > Powered By </span> &nbsp;&nbsp;&nbsp;
            <img src="/static/img/oneplatform/logo_one_platform_2.png" style="height: 30px;cursor: pointer;" @click="openlink('https://one.th/')">
          </div>
            </v-form>
                    </v-flex>
                  </v-layout>
              </v-card-text>
              </v-card>

      </v-layout>
      <!--  -->


      <v-layout row :style="layoutLogin" justify-center = true class="hidden-md-and-up">
        <v-card class="setBolderRegister" style="background-color: #000000b8; width:100vw">
          <v-card-text style="margin-top: 0; padding-left: 40px; padding-right: 40px; ">
            <h2 style="color:white;" class="centerDiv CSChatThai">ลงทะเบียนผู้ใช้งาน</h2>
              <v-layout>
                <v-flex xs12> <v-form v-model="valid" ref="form" class="CSChatThai labeltext">
                  <div style="margin-top: 30px;text-align: center;" v-if="type=='first'">
                    <v-text-field
                      dark
                      label="เบอร์โทรศัพท์"
                      v-model="phoneNumber"
                      mask="###-###-####"
                      :rules="phoneRules"
                      required
                      prepend-icon="phone"
                      single-line
                      style="width: 100% !important; color: #2562af !important;"
                    ></v-text-field>
                    <!-- <v-btn @click="getotp()" color="#2562af" :disabled="phoneNumber === ''" style="justify-self: center;margin-bottom: 30px;width: 20%; border-radius:50px; color:white;">ขอ OTP</v-btn> -->
                    <v-btn  @click="getotp()"  color="#2562af"  :disabled="phoneNumber === ''" style="justify-self: center;margin-bottom: 30px;width: 20%; border-radius:50px; color:white;">ขอ OTP</v-btn>
                  </div>

                    <div style="margin-top: 30px;text-align: center; color:white;" v-else-if="type=='otp'">
                      <p >เบอร์โทร: {{phoneNumber}}</p>
                      <p  v-if="Refcode">Refcode: {{Refcode}}</p>
                      <div style="display: flex;">
                        <v-text-field
                          dark
                          label="OTP"
                          v-model="otpCode"
                          required
                          single-line
                          maxlength="6"
                          style="width: 100% !important; color: #2562af !important;"
                        ></v-text-field>

                        <v-btn depressed class="btnloginwebOneid_white" style="width: 20%; margin-top: 5px !important;" :disabled="counting" @click="getotp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                          <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
                        </countdown>
                        <span v-if="!counting">ส่ง OTP </span>
                      </v-btn>
                    </div>
                  <v-checkbox
                    v-model="checkbox"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    dark>
                    <div slot="label" style="color: #2562af !important;">
                      ยอมรับ
                      <a style="color: gray !important; text-decoration: underline;" @click.stop="conditions = true">เงื่อนไขการใช้งาน</a>
                    </div>
                  </v-checkbox>
                  <v-dialog v-model="conditions" width="70%">
                    <v-card>
                      <v-card-title class="title">เงื่อนไขการใช้งาน</v-card-title>
                      <v-card-text v-html="content">
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        flat
                        color="blue"
                        @click="conditions = false"
                        >ตกลง</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                <div style="justify-content: center; align-items: center; display: flex; margin-bottom: 5vh;">
                  <v-btn @click="backtoInputphone()" outline color="blue-grey" style="color: white !important;border-radius: 20px;">ย้อนกลับ</v-btn>
                  <v-btn
                    @click="loginWithotp()"
                    :disabled="!(valid && otpCode.length==6)"
                    color="success"
                    :loading="isLoading"
                    style="border-radius: 20px;"
                    >
                    สมัครสมาชิก
                  </v-btn>
              </div>
                      </div>
              <div  style="justify-content: center;display: flex;" >
                <span style="color: white; font-size: 12px; color:white;" > Powered By </span> &nbsp;&nbsp;&nbsp;
            <img src="/static/img/oneplatform/logo_one_platform_2.png" style="height: 30px;cursor: pointer;" @click="openlink('https://one.th/')">
          </div>
            </v-form>
                    </v-flex>
                  </v-layout>
              </v-card-text>
              </v-card>

      </v-layout>
    </v-container>
<!-- </div> -->
<Dialogselectaccount :dialogSelectaccount="dialogSelectaccount" :list_accounts="list_accounts" :phoneNumber="phoneNumber"  @closeSelectaccount="closeSelectaccount"  />
</div>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
import Dialogselectaccount from '@/components/chat/dialog/SelectAccount'
export default {
  components: {
    Navbar,
    Dialogselectaccount
  },
  data() {
    return {
      type: 'first',
      phoneNumber: '',
      content: '<h4>เงื่อนไขการใช้บริการ</h4>1.การใช้บริการของเรา <br>&nbsp;&nbsp;&nbsp;1.1 การใช้บริการของเราไม่ได้ทำให้คุณเป็นเจ้าของสิทธิในทรัพย์สินทางปัญญาใดๆ ในบริการหรือเนื้อหาที่คุณเข้าถึง <br>&nbsp;&nbsp;&nbsp;1.2 การใช้บริการจากเรา เราอาจส่งประกาศเกี่ยวกับบริการ ข่าวสารเกี่ยวกับการบริหารจัดการ และข้อมูลอื่นๆ ให้แก่คุณ คุณสามารถเลือกไม่รับการสื่อสารเหล่านี้บางรายการได้ <br>&nbsp;&nbsp;&nbsp;1.3 บริการบางอย่างของเราสามารถใช้บนอุปกรณ์เคลื่อนทึ่ห้ามใช้บริการดังกล่าวในลักษณะที่ทำให้คุณเสียสมาธิและทำให้ไม่สามารถปฏิบัติตามกฎจราจรหรือกฎหมายด้านความปลอดภัย <br><br>2. บัญชี One Platform ของคุณ <br>&nbsp;&nbsp;&nbsp;2.1 คุณอาจต้องมีบัญชี One Platform เพื่อที่จะใช้บริการบางส่วนของเราอาจมีข้อกำหนดอื่นหรือเพิ่มเติมบังคับใช้กับคุณ และผู้ดูแลระบบของคุณอาจสามารถเข้าถึงหรือปิดการใช้งานบัญชีของคุณได้ <br>&nbsp;&nbsp;&nbsp;2.2 เพื่อปกป้องบัญชี One Platform ของคุณ โปรดเก็บรักษารหัสผ่านเป็นความลับ คุณมีความรับผิดชอบต่อกิจกรรมที่เกิดขึ้นบนหรือผ่านบัญชี One Platform ของคุณ พยายามไม่ใช้รหัสผ่านบัญชี One Platform ซ้ำบนแอปพลิเคชันของบุคคลที่สาม <br><br>3. การคุ้มครองข้อมูลส่วนบุคคลและลิขสิทธิ์ <br>&nbsp;&nbsp;&nbsp;3.1 เมื่อคุณใช้บริการของเรา ถือว่าคุณยินยอมให้ One Platform ใช้ข้อมูลดังกล่าวตามนโยบายส่วนบุคคลนั้น <br><br>4. การปรับเปลี่ยนและการยุติการให้บริการของเรา <br>&nbsp;&nbsp;&nbsp;4.1 เราทำการเปลี่ยนแปลงและปรับปรุงบริการของเราอย่างสม่ำเสมอ เราอาจเพิ่มหรือนำ <br>ระบบการทำงานหรือคุณลักษณะบางอย่างออก และเราอาจระงับหรือหยุดให้บริการใดบริการหนึ่งโดยสิ้นเชิง <br>&nbsp;&nbsp;&nbsp;4.2 คุณสามารถหยุดใช้บริการของเราได้ทุกเมื่อ <br><br>5. การใช้บริการของเราในทางธุรกิจ <br>&nbsp;&nbsp;&nbsp;5.1 หากคุณใช้บริการของเราในนามของธุรกิจ ธุรกิจนั้นจะต้องยอมรับข้อกำหนดเหล่านี้ <br>&nbsp;&nbsp;&nbsp;5.2 ธุรกิจจะไม่เรียกร้องให้ One Platform และบริษัทในเครือ เจ้าหน้าที่ ตัวแทน และพนักงานของ One Platform ชดใช้ค่าเสียหายให้แก่คุณ และคุณจะไม่ฟ้องร้องคดีหรือดำเนินการใดๆอันเกิดจากหรือเกี่ยวกับการใช้บริการหรือการละเมิดข้อกำหนดเหล่านี้รวมถึงไม่ให้บุคคลดังกล่าวมีความรับผิดหรือต้องชำระค่าใช้จ่ายใดๆ ที่เกิดจากการเรียกร้องค่าสินไหมทดแทน การสูญเสีย ความเสียหาย การฟ้องร้องคดี การตัดสินคดี ค่าใช้จ่ายในการดำเนินคดี และค่าทนายความ <br>',
      date: null,
      dateShow: null,
      dateThai: null,
      conditions: false,
      valid: false,
      name: '',
      isLoading: false,
      phoneRules: [
        v => (!!v && v.length === 10) || 'กรุณาใส่เบอร์โทรศัพท์ของคุณจำนวน 10 หลัก',
        v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
        v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
      ],
      checkbox: false,
      webdev: process.env.WEBchatdev,
      counting: false,
      otpCode: '',
      mobile_ref_id: '',
      Refcode: '',
      type_otp: '',
      dialogSelectaccount: false,
      list_accounts: [],
      layoutLogin: 'align-items: center; margin-top: 20vh;',
      layoutLoginmo: 'align-items: center; margin-top: 10vh;',
      cardLogin: 'height: auto; width: auto; justify-center; margin-top: 8vh; border-radius: 10px; background-color: #000000b8',
      cardLoginweb: 'margin: 0px; width: 33vw;border-radius: 10px; background:#000000b8; justify-content: center;',

    }
  },
  methods: {
    loginWithotp2() {
      this.isLoading = true
      this.dialogSelectaccount = true
    },
    loginWithotp() {
      this.isLoading = true
      if (localStorage.type_register === 'true') {
        var source = {
          type_otp: this.type_otp,
          phone: this.phoneNumber,
          otp: this.otpCode,
          mobile_ref_id: this.mobile_ref_id,
          consent_status: "Y"
        }
      } else {
        var source = {
          type_otp: this.type_otp,
          phone: this.phoneNumber,
          otp: this.otpCode,
          mobile_ref_id: this.mobile_ref_id
        }
      }
      // console.log(source)
      this.$http.post(process.env.APImanage + '/v2/login_and_regis', source).then((response) => {
        console.log(response.data['status'])
        this.status = response.data['status']
        if (this.status === 'success') {
          // console.log(response)
          if (response.data.list_accounts !== undefined) {
            this.list_accounts = response.data.list_accounts
            // console.log(this.list_accounts)
            this.dialogSelectaccount = true
          } else {
            var profile = response.data['account']['profile']
            this.myprofilepicture = profile['profilepicture']
            this.myname = profile['name']
            // this.$cookie.set('language', 'th')
            localStorage.setItem('Authenrization', Encode.encode({
              'tokenuser': profile['tokenuser'],
              'status_login': 'T',
              'type_user': profile['type']
            }))
            localStorage.setItem('profilepicture', profile['profilepicture'])
            localStorage.setItem('name', profile['name'])
            localStorage.setItem('phone', profile['phone'])
            localStorage.setItem('email', profile['email'])
            localStorage.setItem('status', profile['status'])
            localStorage.setItem('type_user', profile['type'])
            localStorage.setItem('status_login', 'T')
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false')
            } else {
              localStorage.setItem('status_username', 'true')
            }
            this.isLoading = false
            // if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            //   this.$router.push('/chat')
            // } else {
            //   this.$router.push(localStorage.getItem('pathRoom'))
            // }
            if (this.$vuetify.breakpoint.xs == true || this.$vuetify.breakpoint.sm == true) {
              this.$router.push('/mobile/develop/homepage')
            } else {
              this.$router.push('/develop/homepage')
            }
          }
        } else {
          // this.$cookie.set('status_login', 'F')
          localStorage.setItem('status_login', 'F')
          this.isLoading = false
          this.$swal(
            'ขออภัย!',
            'กรอกรหัส OTP ไม่ถูกต้อง',
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.isLoading = false
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    getotp3() {
      this.type = "otp"
      this.dialogSelectaccount = true
    },
    getotp() {
      this.$http.post(process.env.APImanage + '/v2/otp_login_and_regis', {
        phone: this.phoneNumber,
        type: 'register'
      }).then((response) => {
        // console.log(response)
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'register') {
            localStorage.type_register = true
            // console.log('type otp = register')
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type = "otp"
          } else if (response.data.type_otp == 'login') {
            this.$swal(
              'ขออภัย!',
              'หมายเลขโทรศัพท์นี้ได้รับการลงทะเบียนไปแล้ว กรุณาลงชื่อเข้าใช้งานหรือกรอกหมายเลขโทรศัพท์อื่น',
              'error'
            )
            // this.Refcode = response.data.refcode
            // this.mobile_ref_id = response.data.mobile_ref_id
            // this.type_otp = response.data.type_otp
            // this.counting = true
            // this.type="otp"
            // console.log('type otp = login')
          } else if (response.data.type_otp == 'select accounts') {
            // console.log('type otp = select account')
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type = "otp"
            // this.dialogSelectaccount = true
          } else {
            this.phone = ''
            this.$swal(
              'ขออภัย!',
              'หมายเลขโทรศัพท์นี้ได้รับการลงทะเบียนไปแล้ว กรุณาลงชื่อเข้าใช้งานหรือกรอกหมายเลขโทรศัพท์อื่น',
              'error'
            )
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          this.loading = false
          this.$swal(
            'ขออภัย!',
            'ระบบขัดข้อง กรุณาลองใหม่ภายหลัง',
            'error'
          )
        } else if (response.data['message'] === 'too many requests.') {
          this.loading = false
          this.$swal(
            'ขออภัย!',
            'หมายเลขโทรศัพท์นี้ร้องขอ otp บ่อยเกินไป กรุณารอซักครู่แล้วเริ่มทำรายการใหม่',
            'error'
          )
        } else {
          this.loading = false
          this.$swal(
            response.data['status'],
            response.data['message'],
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.isLoading = false
        this.type = 'first'
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    handleCountdownEnd() {
      this.OTP = ''
      this.counting = false
    },
    openlink(path) {
      window.open(path, '_blank')
    },
    toNewTab() {
      window.open(this.webdev, '_blank').focus()
    },
    linkAPI() {
      window.open('/docs', '_blank').focus()
    },
    toPage(page) {
      this.$router.push(page)
    },
    linkregister() {
      window.open('/register').focus()
    },
    linkdownload() {
      window.open('/download').focus()
    },
    isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false
      } else {
        return true
      }
    },
    backtoInputphone() {
      this.$swal({
        title: 'คุณแน่ใจหรือไม่?',
        text: 'คุณกำลังย้อนกลับไปเพื่อกรอกหมายเลขโทรศัพท์ใหม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่, ดำเนินการต่อ!',
        cancelButtonText: 'ไม่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // this.valid = false
          this.type = "first"
          this.phoneNumber = ''
          this.Refcode = ''
          this.mobile_ref_id = ''
          this.type_otp = ''
          this.counting = false
          this.checkbox = false
        }
      })
    },
    closeSelectaccount(value) {
      this.dialogSelectaccount = value
    }
  },
  watch: {
    dialogSelectaccount () {
      // console.log(this.dialogSelectaccount)
      if(this.dialogSelectaccount == false){
        // console.log('test เข้า false')
        this.type="otp"
        this.isLoading = false
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}

.setBolderRegister {
  border-style: solid solid solid solid !important;
  border-width: 1px !important;
  border-radius: 10px !important;
  border-color: #171414 !important;
}

p {
  margin-bottom: 0px;
}

a:link {
  text-decoration: none;
  color: white !important;
}

a:visited {
  color: white !important;
  text-decoration: none;
}

a:hover {
  color: #2562af !important;
  text-decoration: none;
}

a:active {
  color: white !important;
  text-decoration: none;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #00000000 !important;
  color: white;
  text-align: center;
}

.footermo {
  /*position: fixed;*/
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #00000000 !important;
  color: white;
  text-align: center;
}

.centerDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.labeltext {
  color: black !important;
}

.application .input-group.input-group--dirty .input-group__selections__comma:not(.input-group__selections__comma--active),
.input-group.input-group--dirty .input-group__selections__comma:not(.input-group__selections__comma--active) {
  color: black !important;
}

.application .input-group input,
.application .input-group textarea,
.input-group input,
.input-group textarea {
  color: black !important;
}

/*input[type=textregis] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    background-image: url('../assets/image/group.png');
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 50px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
    color: black !important;
}*/

>>>.application .input-group input,
.application .input-group textarea,
.input-group input,
.input-group textarea {
  color: black !important;
}

>>>.input-group label {
  color: #757575 !important;
}

>>>.input-group i {
  color: #2562af !important;
}

>>>i .input-group__prepend-icon {
  color: #2562af !important;
}

>>>.input-group.input-group--error .input-group__messages {
  color: red !important;
}

>>>.input-group__input i {
  color: #2562af !important;
}

>>>.input-group__input input {
  color: #2562af !important;
}

>>>.input-group--text-field input {
  color: black;
}

>>>.input-group__input label {
  color: #2562af !important;
}

>>>.application .input-group:not(.input-group--error) label,
.input-group:not(.input-group--error) label {
  color: #2562af !important;
}

/* >>> .theme--light.v-icon {
  color: rgb(37, 98, 175) !important;
} */
>>>.accent--text {
  color: #2562af !important;
  caret-color: #2562af !important;
}

>>>.theme--dark.v-icon {
  color: #2562af !important;
}

>>>.v-messages__message {
  line-height: normal !important;
}

.btnloginwebOneid_white {
  color: #2562af !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid #2562af;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

>>>[data-v-6d976354] .theme--dark.v-icon {
  color: white !important;
}

>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #f5f5f5 !important;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/new_register.vue